import { HttpEventType, HttpResponse } from '@angular/common/http'
import { Component, ElementRef, Input, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
// TODO:Spartacus - // TODO:Spartacus - Class ModalService has been removed and is no longer part of the public API. Use 'LaunchDialogService' instead. For more information, see the 5.0 migration guide.
import { DialogRef } from '@angular/cdk/dialog'
import { EventEmitter, Output } from '@angular/core'
import { ICON_TYPE, LaunchDialogService } from '@spartacus/storefront'
import { Observable } from 'rxjs'
import { CreditClaimMediaUpload, CreditClaimPhotoAndComment } from '../../../../models/credit-claims.model'
import { CustomLaunchDialogService } from '../../../../services/custom-launch-dialog.service'
import { SharedService } from '../../../../services/shared/shared.service'
import { ShortOversuppliedModalComponent } from '../short-oversupplied-modal/short-oversupplied-modal.component'

@Component({
    selector: 'app-new-credit-claim-photo-upload-modal',
    templateUrl: './new-credit-claim-photo-upload-modal.component.html',
    styleUrls: ['./new-credit-claim-photo-upload-modal.component.scss'],
    standalone: false
})
export class NewCreditClaimPhotoUploadModalComponent implements OnInit {
  public iconTypes = ICON_TYPE
  public fileToUpload: any
  public imageUrl = []
  public newClaimForm: FormGroup
  public maxUploadCount = 4
  public counter = Array
  selectedFiles: FileList
  progressInfos = []
  message = ''
  fileInfos: Observable<any>
  public ImageUrls = []
  public creditClaimMediaUploads: CreditClaimMediaUpload[] = []
  public creditClaimPhotoAndComment: CreditClaimPhotoAndComment = new CreditClaimPhotoAndComment()
  public selectedOption: boolean = false
  public select = ''
  data$: Observable<any>

  @Input() claimComment: string
  creditClaim: any
  addCommentsValue: any
  @Output() submitClicked = new EventEmitter<any>()
  @Input() uploadData: any
  getUploadData: any
  commentFromPopup: ''

  constructor(
    public launchDialogService: LaunchDialogService,
    private sharedService: SharedService,
    private fb: FormBuilder,
    private dialogRef: DialogRef<ShortOversuppliedModalComponent>,
    protected el: ElementRef,
    private customLaunchDialogService: CustomLaunchDialogService
  ) {}

  ngOnInit(): void {
    this.selectedOption = false
    this.newClaimForm = this.fb.group({
      comment: [this.claimComment, [Validators.required]]
    })
    this.select = this.sharedService.userName
    switch (this.select) {
      case 'DAMAGED_STOCK':
        this.selectedOption = true
        break
      case 'FAULTY_STOCK':
        this.selectedOption = true
        break
      case 'REQUEST_RETURN':
        this.selectedOption = true
        break
      case 'OTHER':
        this.selectedOption = true
        break
      case 'SHORT_SUPPLIED':
        this.selectedOption = false
        this.select = ''
        this.sharedService.userName = ''
        break
      case 'SHORT_OVER_SUPPLIED':
        this.selectedOption = false
        this.select = ''
        this.sharedService.userName = ''
        break
      case 'OVER_SIPPLIED':
        this.selectedOption = false
        this.select = ''
        this.sharedService.userName = ''
        break
      default:
        this.selectedOption = false
      // this.select = "";
    }
  }

  public closeModal(comment?: any): void {
    this.addCommentsValue = this.setModalData(comment)
    this.creditClaimPhotoAndComment = this.addCommentsValue
    this.dialogRef.close(this.addCommentsValue)
    this.launchDialogService.dialogClose.subscribe((value: any) => {
      return value
    })
  }

  onPhotoUpload(file: FileList, photoNumber: number): void {
    this.fileToUpload = file.item(0)
    const reader = new FileReader()
    reader.onload = (event: any) => {
      this.imageUrl[photoNumber] = event.target.result
    }
    reader.readAsDataURL(this.fileToUpload)
  }

  selectFiles(event): void {
    this.progressInfos = []
    if (event.target.files && event.target.files[0]) {
      const filesAmount = event.target.files.length
      for (let i = 0; i < filesAmount; i++) {
        const reader = new FileReader()
        reader.onload = (event: any) => {
          this.ImageUrls.push(event.target.result)
        }

        reader.readAsDataURL(event.target.files[i])
      }
    }

    const files = event.target.files
    let isImage = true

    for (let i = 0; i < files.length; i++) {
      if (files.item(i).type.match('image.*')) {
        continue
      } else {
        isImage = false
        alert('invalid format!')
        break
      }
    }

    if (isImage) {
      this.selectedFiles = event.target.files
      this.message = ''

      for (let i = 0; i < this.selectedFiles.length; i++) {
        this.upload(i, this.selectedFiles[i])
      }
    } else {
      this.selectedFiles = undefined
      event.srcElement.percentage = null
    }
  }

  uploadFiles(): void {
    this.message = ''

    for (let i = 0; i < this.selectedFiles.length; i++) {
      this.upload(i, this.selectedFiles[i])
    }
  }

  upload(index, file): void {
    this.progressInfos[index] = { value: 0, fileName: file.name }
    this.sharedService.uploadMedia(file).subscribe(
      (event) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.progressInfos[index].percentage = Math.round((100 * event.loaded) / event.total)
        } else if (event instanceof HttpResponse) {
          this.saveImageData(event.body[0])
        }
      },
      (err) => {
        this.progressInfos[index].percentage = 0
        this.message = 'Could not upload the file:' + file.name
      }
    )
  }

  public saveImageData(creditClaimMediaUpload: CreditClaimMediaUpload): void {
    this.creditClaimMediaUploads.push(creditClaimMediaUpload)
  }

  public setModalData(comment?: string): CreditClaimPhotoAndComment {
    const creditClaimPhotoAndComment: CreditClaimPhotoAndComment = new CreditClaimPhotoAndComment()
    creditClaimPhotoAndComment.creditClaimMediaUploads = this.creditClaimMediaUploads
    if (comment) {
      creditClaimPhotoAndComment.comment = comment
    } else {
      creditClaimPhotoAndComment.comment = ''
    }
    return creditClaimPhotoAndComment
  }
}
